<template>
<basepage title="Sample Page" :status="status" :menuitems="menuItems" v-on:menuclick="menuClick">
  <template slot="toolbar">
    <v-text-field v-model="aranacak" flat="" solo-inverted="" hide-details :label="$t('Search')" append-icon="search"></v-text-field>
    <v-btn :disabled="status.loading" flat @click="kayitgetir()">Ara</v-btn>
  </template>

  main slot burası

</basepage>
</template>

<script>
import basepage from "@/components/app/coper/comp/basepage.vue";
import tool from "../coper/tools";

export default {
  components: {
    basepage,
  },
  data() {
    return {
      status: tool.NewSatatus(),
      aranacak: "",
      menuItems: [{
          title: 'Menu Item 1...'
        },
        {
          title: 'Menu Item 2...'
        },
      ],
    };
  },
  methods: {
    menuClick(index) {
      if (index == 0) {

      } else if (index == 1) {

      }
    },
    kayitgetir() {

    }
  },
  beforeMount: beforeMount,
};

function beforeMount() {

  /*

  var prm = {
      VKN: "9240492097",
    };

      this.status.loading = true;
      tool.api_post (this, "EFatura/VKN_Sorgula", prm).then(

        response => {

          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );
      */

}
</script>
